import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import { IconImage, IconBook, IconMicSmall, IconTrophy } from '../components/Icons';
import './Admin.css';

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({ gallery: '…', publications: '…', grants: '…', speaking: '…' });

  useEffect(() => {
    Promise.all([
      fetch('/api/gallery').then(r => r.json()),
      fetch('/api/publications').then(r => r.json()),
      fetch('/api/grants').then(r => r.json()),
      fetch('/api/speaking').then(r => r.json()),
    ]).then(([ga, p, gr, sp]) => {
      setStats({ 
        gallery:      (ga.items ? ga.items.length : ga.length) || 0, 
        publications: (p.items  ? p.items.length  : p.length)  || 0, 
        grants:       (gr.items ? gr.items.length : gr.length) || 0,
        speaking:     (sp.items ? sp.items.length : sp.length) || 0
      });
    });
  }, []);

  const dashboardCards = [
    { 
      to: '/admin/gallery', 
      icon: <IconImage size={22} />, 
      label: 'Gallery Photos', 
      num: stats.gallery, 
      desc: 'Upload new photos, edit captions, and manage the visual portfolio archives.'
    },
    { 
      to: '/admin/publications', 
      icon: <IconBook size={22} />, 
      label: 'Publications', 
      num: stats.publications, 
      desc: 'Add, edit, and remove journal articles, book releases, and academic chapters.'
    },
    { 
      to: '/admin/speaking', 
      icon: <IconMicSmall size={22} />, 
      label: 'Speaking Events', 
      num: stats.speaking, 
      desc: 'Add global conferences, keynote speeches, and video presentations.'
    },
    { 
      to: '/admin/grants', 
      icon: <IconTrophy size={22} />, 
      label: 'Awards & Grants', 
      num: stats.grants, 
      desc: 'Add academic awards, foundation fellowships, and research grants.'
    },
  ];

  return (
    <AdminLayout title="Dashboard" page="dashboard">
      <div className="admin-content">
        <div className="admin-page-header">
          <h2>Welcome back, Dr. Sofjan</h2>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '1.25rem' }}>
          {dashboardCards.map(card => (
            <a 
              key={card.to} 
              href={card.to} 
              className="admin-stat-card" 
              onClick={e => { e.preventDefault(); navigate(card.to); }}
              style={{ 
                textDecoration: 'none', 
                cursor: 'pointer', 
                flexDirection: 'column', 
                alignItems: 'stretch', 
                gap: '0.85rem' 
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div 
                  className="admin-stat-card__icon" 
                  style={{ 
                    background: 'transparent', 
                    color: 'var(--text-dark)', 
                    border: '1px solid var(--border)', 
                    margin: 0, 
                    width: '42px', 
                    height: '42px',
                    borderRadius: '8px'
                  }}
                >
                  {card.icon}
                </div>
                <span 
                  className="badge" 
                  style={{ 
                    background: 'transparent', 
                    color: 'var(--text-mid)', 
                    border: '1px solid var(--border)',
                    fontSize: '0.75rem', 
                    padding: '0.35rem 0.8rem',
                    borderRadius: '8px',
                    fontWeight: '700',
                    letterSpacing: '0.05em'
                  }}
                >
                  {card.num} ITEM{card.num !== 1 ? 'S' : ''}
                </span>
              </div>
              <div style={{ marginTop: '0.25rem' }}>
                <h4 style={{ fontSize: '0.98rem', color: 'var(--text-dark)', marginBottom: '0.35rem', fontWeight: '700', fontFamily: 'var(--font-sans)' }}>
                  Manage {card.label}
                </h4>
                <p style={{ fontSize: '0.82rem', color: 'var(--text-light)', lineHeight: '1.5', margin: 0 }}>
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
        </div>

        <div style={{ marginTop: '2.5rem', padding: '1rem 1.25rem', background: 'var(--bg-alt)', borderRadius: 'var(--radius-sm)', fontSize: '0.82rem', color: 'var(--text-light)', lineHeight: 1.6 }}>
          <strong style={{ color: 'var(--text-dark)' }}>💡 How to use:</strong> Use the cards above or the sidebar navigation to manage specific content sections.
          Upload photos in <em>Gallery</em>, register articles in <em>Publications</em>, and log grants in <em>Awards & Grants</em>.
          All changes are saved immediately and appear on the public website.
        </div>
      </div>
    </AdminLayout>
  );
}
